import CompleteRegistration from '@/views/login/CompleteRegistrationPage'

export default function Page() {
  return <CompleteRegistration />
}
